import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { OccupationNameRecord } from '../entities/records';
import * as selectors from '../entities/OccupationName/selectors';

function mapStateToProps(state, { occupationNamesIds }) {
  return {
    occupationNames: selectors.occupationNamesByIds(state, occupationNamesIds),
  };
}

export default compose(
  setPropTypes({
    occupationNamesIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    occupationNames: PropTypes.arrayOf(PropTypes.instanceOf(OccupationNameRecord)),
  }),
)(mapStateToProps);
